import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { coreClientProfileApi } from '../api';

export const useClientProfile = (clientId: ApiServerEntityIDType) => {
  return coreClientProfileApi.endpoints.getClientProfile.useQuery({ clientId });
};
